/* eslint-disable no-use-before-define */
import React from 'react'
import useMarketNews from '../use-market-news'
import Select from './select'

export default ({type, dataName="corporates-market-news-date-picker", size=6} = {}) => {

    const a = useMarketNews()
    const isCustom = type==='custom'
    const [dateRange, setDateRange] = isCustom
        ? [a.customDate, a.setCustomDate]
        : [a.holdingDate, a.setHoldingDate]

    const arg = {
        dateRange, setDateRange,
    }

    return <div className="row">
        <Select dataName={dataName} size={size} {...arg} />
    </div>
}



// WEBPACK FOOTER //
// ./src/corporates/market-news/date-picker/date-picker.js